import React, { useState, useEffect } from 'react';

const ChangePassword = () => {
	const API_BASE_URL = process.env.REACT_APP_BASE_URL;
	const [empCode, setEmpCode] = useState('');
	const [oldPassword, setOldPassword] = useState('');
	const [password, setPassword] = useState('');
	const [confirmPassword, setConfirmPassword] = useState('');
	const [error, setError] = useState('');
	const [success, setSuccess] = useState('');
	const [loading, setLoading] = useState(true); // added

	const validatePassword = (password) => {
		const minLength = /.{8,}/;
		const hasUpper = /[A-Z]/;
		const hasLower = /[a-z]/;
		const hasNumber = /[0-9]/;
		const hasSpecial = /[!@#$%^&*(),.?":{}|<>]/;
		const forbiddenWords = /(vijaya|vdc)/i;

		if (!minLength.test(password)) return 'Password must be at least 8 characters long.';
		if (!hasUpper.test(password)) return 'Password must contain at least one uppercase letter.';
		if (!hasLower.test(password)) return 'Password must contain at least one lowercase letter.';
		if (!hasNumber.test(password)) return 'Password must contain at least one number.';
		if (!hasSpecial.test(password)) return 'Password must contain at least one special character.';
		if (forbiddenWords.test(password)) return 'Password should not contain "vijaya" or "vdc".';

		return '';
	};
	useEffect(() => {
  const empCode1 = sessionStorage.getItem('userEmpCode');
  if (empCode1) {
    setEmpCode(empCode1);
  }
  setLoading(false);
}, []);
	

	const handleSubmit = async (e) => {
		e.preventDefault();

		if (loading || !empCode) {
			setError('Employee code not loaded yet. Please wait a moment.');
			setSuccess('');
			return;
		}

		const validationError = validatePassword(password);
		if (validationError) {
			setError(validationError);
			setSuccess('');
			return;
		}

		if (password !== confirmPassword) {
			setError('Passwords do not match');
			setSuccess('');
			return;
		}

		try {
			const formData = new FormData();
			formData.append('bmid', empCode);
			formData.append('old_pass', oldPassword);
			formData.append('pass', password);
			formData.append('conf_pass', confirmPassword);

			const token = sessionStorage.getItem('authToken');
			const response = await fetch(`${API_BASE_URL}changeMyPass1`, {
				method: 'POST',
				headers: {
					Authorization: `Bearer ${token}`,
				},
				body: formData,
			});

			const result = await response.json();

			if (response.ok) {
				setSuccess('Password updated successfully!');
				setError('');
				setEmpCode('');
				setOldPassword('');
				setPassword('');
				setConfirmPassword('');
				sessionStorage.clear();
				window.location.href = '/';
			} else {
				setError(result.message || 'Failed to update password');
				setSuccess('');
			}
		} catch (err) {
			console.error(err);
			setError('Something went wrong');
			setSuccess('');
		}
	};

	return (
		<div style={styles.container}>
			<form onSubmit={handleSubmit} style={styles.form}>
				<h2 style={styles.heading}>Change Password</h2>

				<div style={styles.inputGroup}>
					<label>Old Password</label>
					<input
						type='password'
						value={oldPassword}
						onChange={(e) => setOldPassword(e.target.value)}
						required
						style={styles.input}
					/>
				</div>

				<div style={styles.inputGroup}>
					<label>New Password</label>
					<input
						type='password'
						value={password}
						onChange={(e) => setPassword(e.target.value)}
						required
						style={styles.input}
					/>
				</div>

				<div style={styles.inputGroup}>
					<label>Confirm Password</label>
					<input
						type='password'
						value={confirmPassword}
						onChange={(e) => setConfirmPassword(e.target.value)}
						required
						style={styles.input}
					/>
				</div>

				{error && <p style={styles.error}>{error}</p>}
				{success && <p style={styles.success}>{success}</p>}

				<button type='submit' style={styles.button} disabled={loading}>
					{loading ? 'Please wait...' : 'Update Password'}
				</button>
			</form>
		</div>
	);
};

const styles = {
	container: {
		minHeight: '100vh',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		background: '#f0f2f5',
		padding: '20px',
	},
	form: {
		background: '#fff',
		padding: '30px',
		borderRadius: '8px',
		boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
		width: '100%',
		maxWidth: '400px',
	},
	heading: {
		marginBottom: '20px',
		textAlign: 'center',
	},
	inputGroup: {
		marginBottom: '15px',
	},
	input: {
		width: '100%',
		padding: '10px',
		fontSize: '14px',
		border: '1px solid #ccc',
		borderRadius: '5px',
	},
	button: {
		width: '100%',
		padding: '10px',
		backgroundColor: '#007bff',
		color: '#fff',
		border: 'none',
		borderRadius: '5px',
		cursor: 'pointer',
		fontSize: '16px',
	},
	error: {
		color: 'red',
		fontSize: '14px',
		marginTop: '10px',
	},
	success: {
		color: 'green',
		fontSize: '14px',
		marginTop: '10px',
	},
};

export default ChangePassword;
